import styled from "styled-components";
import theme from "@src/Tools/MuiTheme";

export const STContentWrapper = styled.div`
  flex-grow: 1;
  padding: 15px 15px 0;
  padding-top: 80px;
  background-color: #ffffff;
`;

export const STGridContent = styled.div`
  && {
    width: calc(100% - 240px);
    ${theme.breakpoints.down("sm")} {
      width: 100%;
    }
  }
`;
